import { ColonistMembershipType, ColonistOneTimePurchaseType, LobbyImage } from '@colonist/types';
import { createDivIn, createHeaderIn, createImgIn, setElementOnClick } from '../../ui_utils/DomUtils.ts';
import { UIStoreGiftRecipientSelectionController } from './UIStoreGiftRecipientSelectionController.ts';
import '../../../css/theme/_store_gift_overlay.scss';
import { UIStoreGiftTierSelectionController } from './UIStoreGiftTierSelectionController.ts';
import { UIStoreGiftDetailsSelectionController } from './UIStoreGiftDetailsSelectionController.ts';
import { UICheckoutAjaxEndPoints } from '../../ui_checkout/UICheckoutAjaxEndPoints.ts';
import { GiftPurchaseType } from '../../../../../shared/store/GiftPurchaseData.ts';
import { UIAjaxWrapper } from '../../network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../../network/UIAPIEndpoints.ts';
import { showSimpleDialog } from '../../ui_popup/showSimpleDialog.ts';
import { UIUtilsNotifications } from '../../notifications/UIUtilsNotifications.ts';
import { getNestedTranslation } from '@colonist/i18n';
import { getHomepageUrl, navigateToPage } from '../../ui_utils/ClientUtils.ts';
import { HTTPStatus } from '../../../../../shared/errors/ErrorEnums.ts';
import { notificationController } from '../../EntryShared.ts';
import { UIStoreGiftBaseSelectionController } from './UIStoreGiftBaseSelectionController.ts';
import { GiftingFlowAnalytics } from '../../../../../shared/entity_datas/EntityDatas.ts';
import { ClientUserState } from '../../ClientUserState.ts';
import { ViewPopupLogin } from '../../ui_popup/ui_popup_membership_incentive/ViewPopupLogin.ts';
import { StoreProductType } from '../../../../../shared/store/BaseColonistStoreProduct.ts';
import { sendPurchaseSessionStartedAnalytic } from '../../analytics/sendPurchaseFunnelAnalytic.ts';
export class UIStoreGiftOverlayController {
    init() {
        const hash = window.location.hash;
        let username;
        if (hash == '#gift') {
            var _ClientUserState_userState;
            const params = new URLSearchParams(window.location.search);
            username = params.get('username') || undefined;
            if (!((_ClientUserState_userState = ClientUserState.userState) === null || _ClientUserState_userState === void 0 ? void 0 : _ClientUserState_userState.isLoggedIn)) new ViewPopupLogin(true, 'gift');
        }
        this.createHeaderSection();
        this.createBodySection(username);
        if (hash !== '#gift') this.hide();
        if (!hash.includes('#redeem')) return;
        void UIStoreGiftOverlayController.redeemCode(hash);
    }
    createHeaderSection() {
        const headerContainer = createDivIn(this.mainContainer, 'store-gift-overlay-header-container');
        const colonistLogo = createImgIn(headerContainer, LobbyImage.Logo);
        setElementOnClick(colonistLogo, ()=>this.goToHomepage());
        createHeaderIn(headerContainer, {
            key: 'strings:storePage.sections.giftOverlay.title'
        }, '', '', 'H2');
        const closeButton = createImgIn(headerContainer, LobbyImage.XMark, 'store-gift-overlay-close-button');
        setElementOnClick(closeButton, ()=>this.hide());
    }
    createBodySection(username) {
        const bodyContainer = createDivIn(this.mainContainer, 'store-gift-overlay-body-container');
        const sidebarContainer = createDivIn(bodyContainer, 'store-gift-overlay-sidebar-container');
        const selectionContainer = createDivIn(bodyContainer, 'store-gift-overlay-tabs-container');
        const hideGiftOverlayAction = ()=>this.hide();
        const checkoutAction = ()=>this.checkout();
        const shouldRecipientSelectionBeFirstPage = username != undefined;
        this.tierSelectionController = new UIStoreGiftTierSelectionController(selectionContainer, sidebarContainer, this.storeState, hideGiftOverlayAction, checkoutAction, shouldRecipientSelectionBeFirstPage, this.localizedStoreProductData);
        this.recipientSelectionController = new UIStoreGiftRecipientSelectionController(selectionContainer, sidebarContainer, hideGiftOverlayAction, checkoutAction, username);
        this.detailsSelectionController = new UIStoreGiftDetailsSelectionController(selectionContainer, sidebarContainer, checkoutAction, hideGiftOverlayAction);
        this.tierSelectionController.select();
        if (!shouldRecipientSelectionBeFirstPage) return;
        this.reorderPages(true);
    }
    reorderPages(shouldRecipientSelectionBeFirstPage) {
        if (shouldRecipientSelectionBeFirstPage) {
            this.recipientSelectionController.makePageFirst();
            this.recipientSelectionController.select();
        } else {
            this.tierSelectionController.makePageFirst();
            this.tierSelectionController.select();
        }
    }
    checkout() {
        var _this_detailsSelectionController;
        const giftTier = this.tierSelectionController.selectedTier;
        const giftDuration = this.tierSelectionController.giftDuration;
        const isGiftLinkSelected = this.recipientSelectionController.isGiftLinkSelected;
        const receiverUsername = this.recipientSelectionController.recipientUsername;
        var _this_detailsSelectionController_giftMessage;
        const giftMessage = (_this_detailsSelectionController_giftMessage = (_this_detailsSelectionController = this.detailsSelectionController) === null || _this_detailsSelectionController === void 0 ? void 0 : _this_detailsSelectionController.giftMessage) !== null && _this_detailsSelectionController_giftMessage !== void 0 ? _this_detailsSelectionController_giftMessage : '';
        if (giftTier == undefined) return this.tierSelectionController.select();
        if (!isGiftLinkSelected && receiverUsername == undefined) return this.recipientSelectionController.select();
        const giftPurchaseData = {
            giftPurchaseType: isGiftLinkSelected ? GiftPurchaseType.GiftURL : GiftPurchaseType.GiftToUser,
            oneTimePurchaseType: giftTier,
            receiverUsername: receiverUsername,
            duration: giftDuration,
            giftMessage: giftMessage
        };
        void this.executeCheckout(giftTier, giftPurchaseData);
    }
    // eslint-disable-next-line class-methods-use-this
    async executeCheckout(giftTier, giftPurchaseData) {
        sendPurchaseSessionStartedAnalytic({
            storeProductType: StoreProductType.OneTimePurchase,
            productType: giftTier,
            method: 'stripeCheckout'
        });
        UIStoreGiftBaseSelectionController.sendGiftFlowAnalytics(GiftingFlowAnalytics.SuccessfulCheckoutClick);
        void UICheckoutAjaxEndPoints.executeStripeColonistGiftPurchaseSession(giftTier, giftPurchaseData);
    }
    // eslint-disable-next-line class-methods-use-this
    goToHomepage() {
        navigateToPage(getHomepageUrl());
    }
    hide() {
        this.mainContainer.classList.add('hidden');
    }
    show() {
        notificationController.removeDisconnectBanners() // TODO: Oguz, December 2024. Added because of bugged code. We may discuss enabling once https://github.com/colonistio/katan/issues/18162 is fixed
        ;
        this.tierSelectionController.select();
        this.mainContainer.classList.remove('hidden');
        this.resetForm();
    }
    resetForm() {
        var _this_detailsSelectionController;
        this.recipientSelectionController.resetInputField();
        this.recipientSelectionController.disableNextButton();
        this.tierSelectionController.deselectAllGiftTiers();
        (_this_detailsSelectionController = this.detailsSelectionController) === null || _this_detailsSelectionController === void 0 ? void 0 : _this_detailsSelectionController.resetForm();
        if (!this.recipientSelectionController.isGiftLinkSelected) return;
        this.recipientSelectionController.selectExistingPlayerToggle.click();
    }
    selectGiftTier(membershipType) {
        switch(membershipType){
            case ColonistMembershipType.EliteMonthly:
                this.tierSelectionController.selectGiftTier(ColonistOneTimePurchaseType.GiftEliteMonthly, membershipType);
                break;
            case ColonistMembershipType.EliteYearly:
                this.tierSelectionController.selectGiftTier(ColonistOneTimePurchaseType.GiftEliteYearly, membershipType);
                break;
            case ColonistMembershipType.PremiumMonthly:
                this.tierSelectionController.selectGiftTier(ColonistOneTimePurchaseType.GiftPremiumMonthly, membershipType);
                break;
            case ColonistMembershipType.PremiumYearly:
                this.tierSelectionController.selectGiftTier(ColonistOneTimePurchaseType.GiftPremiumYearly, membershipType);
                break;
            case ColonistMembershipType.PlusMonthly:
                this.tierSelectionController.selectGiftTier(ColonistOneTimePurchaseType.GiftPlusMonthly, membershipType);
                break;
            case ColonistMembershipType.PlusYearly:
                this.tierSelectionController.selectGiftTier(ColonistOneTimePurchaseType.GiftPlusYearly, membershipType);
                break;
            case ColonistMembershipType.Holiday2023AllAccessPass:
                throw new Error('Invalid membership type');
        }
    }
    static async redeemCode(hashWithoutParameters) {
        const redeemCode = hashWithoutParameters.split('=')[1];
        const codeRedeemResponse = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiGetGiftMembershipData(redeemCode), undefined);
        const giftMembershipData = codeRedeemResponse === null || codeRedeemResponse === void 0 ? void 0 : codeRedeemResponse.json.data;
        if (giftMembershipData == undefined) return;
        const popupTitle = {
            key: 'strings:imgAlts.StoreGiftMembership'
        };
        const giftTier = UIUtilsNotifications.getMembershipTitleFromType(giftMembershipData.membershipType);
        const popupBody = getNestedTranslation({
            key: 'strings:storePage.sections.giftOverlay.membershipReceived',
            options: {
                count: giftMembershipData.lengthMonths,
                gifter: `${giftMembershipData.senderName}`,
                message: giftMembershipData.message
            }
        }, {
            giftTier: giftTier
        });
        showSimpleDialog({
            title: popupTitle,
            body: popupBody,
            onConfirm: async ()=>{
                const response = await UIAjaxWrapper.postRequestHandler(UIAPIEndpoints.apiRedeemGiftFromHash(), undefined, {
                    hash: redeemCode
                });
                if ((response === null || response === void 0 ? void 0 : response.status) == HTTPStatus.Ok) navigateToPage(getHomepageUrl());
            }
        });
        return giftMembershipData;
    }
    updateRecipient(giftUsername) {
        this.resetForm();
        if (giftUsername == undefined) return;
        this.recipientSelectionController.setRecipient(giftUsername);
    }
    constructor(parentDiv, storeState, localizedStoreProductData = []){
        this.localizedStoreProductData = [];
        this.mainContainer = createDivIn(parentDiv, 'store-gift-overlay-container');
        this.storeState = storeState;
        this.localizedStoreProductData = localizedStoreProductData;
        this.init();
    }
}
